import { useEffect, useRef, useState } from 'react';
import ErrorMessage from '../ErrorMessage';
import Service from '../../Service';

function StreetView(props) {
	const service = new Service();
	const [error, setError] = useState(false);
	const panoramaRef = useRef(null);

	useEffect(() => {
		initStreetView();
	}, [props.address]);

	/**
	 *
	 * @returns {Promise<void>}
	 */
	async function initStreetView() {
		// @ts-ignore -- Added by Google script
		if (window.google === undefined) {
			return;
		}

		const coordinates = await getCoordinates();

		if (coordinates === undefined) {
			return;
		}

		const fenway = {
			lat: coordinates.latitude,
			lng: coordinates.longitude,
		};

		// @ts-ignore -- Added by Google script
		panoramaRef.current = new window.google.maps.StreetViewPanorama(
			document.getElementById('pano'),
			{
				position: fenway,
				pov: {
					heading: 34,
					pitch: 10,
				},
			}
		);
	}

	async function getCoordinates() {
		const encodedAddress = encodeURIComponent(props.address);

		try {
			const response = await service.getCoordinates(encodedAddress);

			return { latitude: response.lat, longitude: response.lng };
		} catch (error) {
			setError('Unable to retrieve coordinates.');
		}
	}

	if (error) {
		return (
			<ErrorMessage
				heading="Error"
				message="Unable to render street view."
			/>
		);
	}

	return (
		<div className="my-6">
			<div id="pano" style={{ width: '100%', height: '400px' }} />
		</div>
	);
}

export default StreetView;
